// @flow
import * as React from 'react'
import Alert from 'ui/Alert'

type Props = {
  errors?: string[],
}

export default function Errors({ errors }: Props) {
  if (errors && errors.length) {
    return (
      <div style={{ marginBottom: '12px' }}>
        <Alert type="error">
          {errors.map((e, i) => (
            <div key={i}>{e}</div>
          ))}
        </Alert>
      </div>
    )
  }
  return null
}
